import { Nullable } from '@clearverify/types';

import {
  EmployerListItemForVerificationRequestInfoFragment,
  VerificationRequestType,
  VerifiersListQuery,
} from 'src/api';
import { VerificationRequestCreateFormFields } from 'src/constants/verificationRequest';

export enum VerificationRequestCreateByCVStaffFormFields {
  verifier = 'verifier',
}

export type VerificationRequestCreateFormValues = {
  [VerificationRequestCreateByCVStaffFormFields.verifier]: VerifiersListQuery['verifierList'][number];
  [VerificationRequestCreateFormFields.ssn]: string;
  [VerificationRequestCreateFormFields.employeeFirstName]: string;
  [VerificationRequestCreateFormFields.employeeLastName]: string;
  [VerificationRequestCreateFormFields.employeeDateOfBirth]: string;
  [VerificationRequestCreateFormFields.verificationReportType]: VerificationRequestType;
  [VerificationRequestCreateFormFields.permissiblePurposeId]: string;
  [VerificationRequestCreateFormFields.noteToEmployee]: string;
  [VerificationRequestCreateFormFields.employers]: EmployerListItemForVerificationRequestInfoFragment[];
  [VerificationRequestCreateFormFields.error]: Nullable<string>;
};
